// extracted by css-extract-rspack-plugin
export default {"chip":"qCi4c3OLDikEFZKW","chipCompact":"e7RlZj5jaNYihhMA"};